import { actions } from './actions'

const initialState = {
  loading: false,
  popupSuccess: false
}

export const reducerAdminAffiliates = (state = initialState, action) => {
  switch (action.type) {
    case actions.set_state:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
